import { hasAuthSession } from "./authSession.mjs";

export function normalizeSmartTrackerSessionState(value, fallback = "stopped") {
  const normalized = String(value || "").trim().toLowerCase();
  if (normalized === "active" || normalized === "paused" || normalized === "stopped") {
    return normalized;
  }
  return fallback;
}

export function normalizeSmartTrackerPositiveInt(value, fallback, min, max) {
  const parsed = Number.parseInt(String(value ?? ""), 10);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(max, Math.max(min, parsed));
}

export function resolveSmartTrackerModuleKey(routePath) {
  const normalized = String(routePath || "").trim().toLowerCase();
  if (!normalized || normalized === "/") return "app-home";
  if (normalized.startsWith("/ncrm/leads")) return "crm-leads";
  if (normalized.startsWith("/ncrm/deals")) return "crm-deals";
  if (normalized.startsWith("/ncrm/contacts")) return "crm-contacts";
  if (normalized.startsWith("/ncrm/activities")) return "crm-activities";
  if (normalized.startsWith("/ncrm/data-integrations")) return "crm-integrations";
  if (normalized.startsWith("/ncrm")) return "crm-board";
  if (normalized.startsWith("/hr-dashboard")) return "hr-dashboard";
  if (normalized.startsWith("/dashboard")) return "employee-dashboard";
  const firstSegment = normalized.split("/").filter(Boolean)[0] || "app";
  return `app-${firstSegment}`;
}

export function hasSmartTrackerAuthToken(storage = globalThis?.localStorage) {
  return hasAuthSession(storage);
}

export function createSmartTrackerInitialState({ idleSeconds = 180, promptSeconds = 30 } = {}) {
  return {
    initialized: false,
    enabled: false,
    ready: false,
    routePath: "",
    moduleKey: "",
    sessionId: null,
    sessionState: "stopped",
    lastActivityAt: 0,
    lastHeartbeatAt: 0,
    idleSeconds,
    promptSeconds,
    promptVisible: false,
    promptCountdown: promptSeconds,
    promptDeadlineAt: 0,
    errorMessage: "",
  };
}
